export const MEMBERSHIP_EXTRA_DATA = {
  PREMIUM: {
    title: 'Anual',
    numberOfAccounts: '1 Cuenta',
  },
  PREMIUM_DUO: {
    isHighlighted: true,
    title: 'Dúo',
    numberOfAccounts: 'Hasta 2 cuentas.',
  },
  FAMILIAR: {
    title: 'Familiar',
    numberOfAccounts: 'Hasta 4 cuentas.',
  },
};
